// extracted by mini-css-extract-plugin
module.exports = {"logTable":"styles_logTable__3l6gY","logModal":"styles_logModal__3_BD2","expandedTable":"styles_expandedTable__2T8dd"};